import React, { useState } from 'react';

import ShareIndustryModal from '../shared/ShareIndustryModal';

const validateEmail = ({ email }) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const followCompany = (props, id, isFollowed, user, companyType) => {
  const { followCompanyType, getCompanyTypeListings } = props;
  followCompanyType(id, isFollowed ? 'unfollow' : 'follow', companyType, user && user.id ? user.id : navigator.userAgent).then(() => {
    getCompanyTypeListings(id, user && user.id ? user.id : navigator.userAgent);
  });
};

const likeCompany = (props, id, isLiked, user, companyType) => {
  const { likeCompanyType, getCompanyTypeListings } = props;
  likeCompanyType(id, isLiked ? 'unlike' : 'like', companyType, user && user.id ? user.id : navigator.userAgent).then(() => {
    getCompanyTypeListings(id, user && user.id ? user.id : navigator.userAgent);
  });
};

const CompanyDetailSection = (props) => {
  const { history, data, numberOfPeople, getIndustryDetails, shareCompany, subscribe, companyType, user } = props;
  const {
    since, 
    total_students, 
    no_of_attendees, 
    funded: raised, 
    goal,
    suppoters,
    shares,
    id,
    isFollowed,
    isLiked,
    weeks_left,
    likes,
    follows,
    text2,
    text3,
    text4,
    text5,
    text6,
    text7,
    text8,
    avatar, 
    // cover_image 
  } = data || {};

  // let coverImage = '/images/school-logo.jpg';
  // if (cover_image) {
  //   coverImage = `${process.env.REACT_APP_BACKEND_BASE_URL}/${cover_image}`;
  // }
  let avatarImage = '/images/school-logo.jpg';
  if (avatar) {
    avatarImage = `${process.env.REACT_APP_BACKEND_BASE_URL}/${avatar}`;
  }
  const [email, setEmail] = useState('');
  const isValidEmail = validateEmail({ email });
  const [isShareModalVisible, setShareModalVisibility] = useState(false);
  return (
    <section className="blog-datil school-detail-sec-2">
      <div className="container">
        <div className="row ">
          <div className="col-lg-8 col-md-8 col-sm-12 iCause-Partners">
            <div className="school-stats">
              <div className="school-logo">
                <img src={avatarImage} className="img-fluid" alt="img" />
              </div>
              <div className="stats-outer-wrap">
                <div className="stats-wrap">
                  <div className="stat-box">
                    <p className="tag">SINCE</p>
                    <p className="number">{since}</p>
                  </div>
                  <div className="stat-box">
                    <p className="tag">TOTAL STUDENTS</p>
                    <p className="number">{total_students}</p>
                  </div>
                  <div className="stat-box">
                    <p className="tag">NO. OF ATTENDEES</p>
                    <p className="number">{no_of_attendees}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="school-detail-text">
              <h4 className="mt-3">About us</h4>
              <p className="">{text2}</p>
              <p className="">{text3}</p>
              <p>{text4}</p>
              <p>{text5}</p>


              <ul className="mt-3 mb-3">
                <li>{text6}</li>
                <li>{text7}</li>
                <li>{text8}</li>
              </ul>
              <h4>How it works</h4>
              <p className="">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.</p>
              <p className="">If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.</p>
              <p>It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p>
              <h6 className="text-right">{likes} Likes <span style={{ marginLeft: 15 }}>{follows} Follows</span></h6>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="campaignSec1-text">
              <div className="btns-wrap">
                <button type="button" onClick={() => history.push(`/${companyType.toLowerCase()}-donate/${id}`)} className="btn-success">
                  {/* <a style={{ color: 'white' }}> */}
                    <img src="/images/donate-icon.png" alt="icon" className="img-fluid" />
                      DONATE NOW
                  {/* </a> */}
                </button>
                <button onClick={() => setShareModalVisibility(true)}  type="button" className=""><img src="/images/share-icon.png" alt="icon" className="img-fluid" />SHARE</button>
              </div>
              <div className="donation-info-wrap">
                <div className="donation-info-box">
                  <h3>${raised} raised</h3>
                  <h4>of ${goal} goal</h4>
                </div>
                <ul className="donation-stats-box mb-3">
                  <li>
                    <h4>{suppoters}</h4>
                    <h5>Supporter</h5>
                  </li>
                  <li>
                    <h4>{shares}</h4>
                    <h5>Shares</h5>
                  </li>
                  <li>
                    <h4>{weeks_left}</h4>
                    <h5>Weeks Left</h5>
                  </li>
                </ul>
                <div className="btns-wrap btns-wrap-2 mt-4">
                  <button 
                  onClick={() => likeCompany(props, id, isLiked, user, companyType)}
                  type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.2" height="18" viewBox="0 0 19.2 18">
                      <g id="like_3_" data-name="like (3)" transform="translate(0 -0.75)">
                        <path id="Path_2376" data-name="Path 2376" d="M1.4,20h2a1.4,1.4,0,0,0,1.4-1.4V9.4A1.4,1.4,0,0,0,3.4,8h-2A1.4,1.4,0,0,0,0,9.4v9.2A1.4,1.4,0,0,0,1.4,20Z" transform="translate(0 -1.45)" fill="#3cb64f" />
                        <path id="Path_2377" data-name="Path 2377" d="M11.725.75c-.8,0-1.2.4-1.2,2.4,0,1.9-1.841,3.43-3.025,4.218v9.91a18.647,18.647,0,0,0,7.825,1.471H16.6a3.2,3.2,0,0,0,3.152-2.656l.9-5.2A3.2,3.2,0,0,0,17.5,7.15H13.725a7.725,7.725,0,0,0,.6-3.2,2.938,2.938,0,0,0-2.6-3.2Z" transform="translate(-1.5)" fill="#3cb64f" />
                      </g>
                    </svg>
                    {isLiked ? 'Unlike' : 'Like'}
                    </button>
                  <button
                  onClick={() => followCompany(props, id, isFollowed, user, companyType)}
                  type="button">
                    <svg fill={isFollowed ? 'red' : ''} xmlns="http://www.w3.org/2000/svg" width="19.104" height="16.996" viewBox="0 0 19.104 16.996">
                      <path id="heart" d="M17.589,1.663A5.137,5.137,0,0,0,13.767,0a4.806,4.806,0,0,0-3,1.036A6.141,6.141,0,0,0,9.552,2.3,6.138,6.138,0,0,0,8.339,1.036,4.805,4.805,0,0,0,5.337,0,5.137,5.137,0,0,0,1.516,1.663,5.971,5.971,0,0,0,0,5.741,7.11,7.11,0,0,0,1.9,10.4a40.4,40.4,0,0,0,4.743,4.452c.657.56,1.4,1.195,2.176,1.871a1.121,1.121,0,0,0,1.477,0c.773-.676,1.519-1.312,2.176-1.872A40.38,40.38,0,0,0,17.209,10.4,7.11,7.11,0,0,0,19.1,5.741a5.971,5.971,0,0,0-1.515-4.078Zm0,0" transform="translate(0)" />
                    </svg>
                    {isFollowed ? 'UnFollow' : 'Follow'}
                  </button>
                </div>
              </div>
            </div>
            <div className="need-our-one need-our-bg blog-sec-2-img">
              <div>
                <h4>{numberOfPeople} Peoples<span className="d-block  "> Need Ours Help</span></h4>
                <button type="button" className="btn btn-success  ml-2 btn_hover">Donate Now</button>
              </div>
            </div>
            <div className="subscribe mt-4">
              <h5>Subscribe for Our News Letter!</h5>
              <p>By subscribing you agree to receive special news and related offers from iCasue.</p>
              <input onChange={({ target }) => setEmail(target.value)} value={email} type="email" name="" className="form-control mt-4" placeholder="You@example.com" />
              <button 
                onClick={() => {
                  subscribe({ email }).then(() => setEmail(''));
                }}
                type="button" 
                disabled={!isValidEmail} 
                className="btn btn-success  mt-2 btn_hover">
                  subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
      <ShareIndustryModal 
        industryId={id}
        user={user}
        shareCompany={shareCompany}
        getIndustryDetails={getIndustryDetails}
        isShareModalVisible={isShareModalVisible}
        setShareModalVisibility={setShareModalVisibility}
      />
    </section>
  );
};

export default CompanyDetailSection;